<template>
  <PageHeader
    :title="`John Doe's details`"
    :subtitle="`ID: ${userDetails.id} | Email: ${userDetails.email}`"
    :back-route="{ name: 'manage-users' }"
  />

  <TableLayout>
    <UserDetailsMetrics :userDetails="userDetails" />

    <template v-if="userDetails?.reports?.length">
      <h2 class="mb-20px">Reports</h2>
      <ReportsTable :reports="userDetails.reports" :back-route="{ name: 'user-details', params: { id: userId } }" />
    </template>
  </TableLayout>
</template>

<script setup>
import { onMounted } from "vue";
import { useRoute } from "vue-router";

import { useUserDetails } from "@/composables/useUserDetails";
import PageHeader from "@/components/PageHeader.vue";
import TableLayout from "@/layouts/TableLayout.vue";
import ReportsTable from "@/views/ReportsView/components/ReportsTable.vue";
import UserDetailsMetrics from "@/views/UserDetailsView/components/UserDetailsMetrics.vue";

const route = useRoute();
const userId = route.params.id;

const { userDetails, fetchUserDetails } = useUserDetails();

onMounted(async () => {
  await fetchUserDetails(userId);
});
</script>
